var _mtm = window._mtm = window._mtm || [];

_mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});

(function () {
        var d = document,
            g = d.createElement('script'),
            s = d.getElementsByTagName('script')[0];

        g.async = true;
        g.src = 'https://matomo.meinhplus.de/statistic/js/container_ui0b9eaK_test_7d203cb35b57cb090339b8e6.js';
        s.parentNode.insertBefore(g, s);
    }
)();